import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import type { BrandLogoProps } from '../src/logo/BrandLogoProps';

const StyledAltivantLogo = styled.img<{ isBackground?: boolean; opacity?: number }>`
  display: inline-block;
  ${({ isBackground, opacity }) =>
    isBackground
      ? ` opacity: 0.1;
  position: absolute;
  left: 50%;
  margin-left: -150px;
  top: 70px;`
      : ` opacity: ${opacity};`}
`;

export const BrandLogo = ({ className, isBackground, opacity, showText, height }: BrandLogoProps) => {
  const logoHeight = height || (showText ? 47 : 30);
  const { Images } = useContext(ThemeContext);

  if (showText) return <img src={Images.vennProvidedLogo} alt="[brand logo] by two sigma" height={logoHeight} />;
  return (
    <StyledAltivantLogo
      src={Images.brandLogo}
      className={className ?? 'altivant-logo'}
      alt="altivant logo"
      height={logoHeight}
      width={logoHeight}
      isBackground={isBackground}
      opacity={opacity}
    />
  );
};

export default BrandLogo;
